// components/Footer/Footer.jsx
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* MARCA */}
        <div className="footer-brand">
          <img src="/images/logo.jpg" alt="Piazada dos Mantos" />
          <div className="footer-brand-text">
            <strong>Piazada dos Mantos</strong>
            <span>Seu catálogo de camisas de futebol. ⚽🔥</span>
          </div>
        </div>

        {/* CONTATOS */}
        <div className="footer-contact">
          <h4>Contato</h4>

          <div className="socials">
            <a
              href="https://instagram.com/piazadadosmantos"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>

            <a
              href="https://wa.me/5541999716047"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>

      <span className="footer-copy">© 2026 Piazada dos Mantos</span>
    </footer>
  );
}
